import { Props } from '../layout.type';

export const LayoutEmptyFull = ({ children }: Props) => {
  return <div className='mx-auto px-4 lg:px-0 min-h-screen'>{children}</div>;
};
